import { supabase } from '../supabaseClient';
import { format } from 'date-fns';

// Calendar Classes
export const fetchCalendarClasses = async () => {
  const { data, error } = await supabase.from('calendarclass').select('id, class, date, starttime, endtime, color, comment, maxattendees').order('date');

  if (error) {
    alert(`Error loading calendar classes: ${error.message}`);
    throw error;
  }
  return data;
};

export const createUpdateCalendarClass = async (calendarClassId, classId, date, startTime, endTime, color, comment, maxAttendees) => {
  const payload = {
    class: Number(classId),
    date: format(date, 'yyyy-MM-dd'),
    
    starttime: startTime,
    endtime: endTime,
    color: color,
    comment: comment,
    maxattendees: maxAttendees
  };

  let { error } = {};
  if (calendarClassId) {
    ({ error } = await supabase.from('calendarclass').update(payload).eq('id', calendarClassId));
  } else {
    ({ error } = await supabase.from('calendarclass').insert([payload]));
  }

  if (error) {
    alert(`Error al guardar la clase: ${error.message}`);
    throw error;
  }
  return true;
}

export const deleteCalendarClass = async (calendarClassId) => {
  const { error } = await supabase.from('calendarclass').delete().eq('id', calendarClassId);

  if (error) {
    alert(`Error al eliminar la clase: ${error.message}`);
    throw error;
  }
  return true;
};

export const createCalendarClasses = async (rows) => {
  const { error } = await supabase.from('calendarclass').insert(rows);

  if (error) {
    alert(`Error al guardar las clases: ${error.message}`);
    throw error;
  }
  return true;
};
